import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Deployment feature flags from the backend (`GET /api/app-config`).
 * `singleBusiness` tailors the UI to one business: hides industry Starter Packs,
 * sample data, terminology, and the workspace switcher.
 * `signupEnabled` is false in the desktop app: no "Create account" / Google
 * sign-in (people join a private install via an owner's invite).
 */
const AppConfigContext = createContext({ singleBusiness: false, globalFields: false, defaultCurrency: "USD", desktop: false, signupEnabled: true, ready: false });

export function AppConfigProvider({ children }) {
  const [cfg, setCfg] = useState({ singleBusiness: false, globalFields: false, defaultCurrency: "USD", desktop: false, signupEnabled: true, ready: false });

  useEffect(() => {
    let cancelled = false;
    api.get("/app-config")
      .then((r) => {
        if (cancelled) return;
        setCfg({
          singleBusiness: !!r.data?.single_business,
          globalFields: !!r.data?.global_fields,
          defaultCurrency: r.data?.default_currency || "USD",
          desktop: !!r.data?.desktop,
          signupEnabled: r.data?.signup_enabled !== false,
          appVersion: r.data?.app_version || null,
          ready: true,
        });
      })
      .catch(() => { if (!cancelled) setCfg((c) => ({ ...c, ready: true })); });
    return () => { cancelled = true; };
  }, []);

  return <AppConfigContext.Provider value={cfg}>{children}</AppConfigContext.Provider>;
}

export function useAppConfig() {
  return useContext(AppConfigContext);
}
